import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Page = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  color: #fff;
`;

const OrderSuccess = () => {
  useEffect(() => {
    // could clear local cart here if desired
  }, []);
  return (
    <Page>
      <h2 style={{ color: '#e1d6c0' }}>Payment Successful</h2>
      <p>Thanks for your order, it has been recieved! Orders typically take around 30 minutes to make.</p>
      <p>
        You can return to the <Link to="/menu">Menu</Link> or go to the <Link to="/">Home</Link> page.
      </p>
    </Page>
  );
};

export default OrderSuccess;